import { Controller } from 'stimulus'
import BSN from 'bootstrap.native/dist/bootstrap-native.esm.min.js'

export default class extends Controller {
  connect() {
    this.copyButton.addEventListener('click', this.copyLink.bind(this))
  }

  openModal(e) {
    this.code = e.currentTarget.dataset.code

    this.affiliateLinkOutput.innerHTML = this.createUrl(this.code)
    this.affiliateCodeOutput.innerHTML = this.code

    this.modal.show()
  }

  copyLink() {
    if(navigator.clipboard) navigator.clipboard.writeText(this.createUrl(this.code))
  }

  createUrl(code) {
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set('af', code)

    return currentUrl.toString()
  }

  get affiliateLinkOutput() {
    return document.getElementById('affiliate-link-output')
  }

  get affiliateCodeOutput() {
    return document.getElementById('affiliate-code-output')
  }

  get modalElement() {
    return document.getElementById('create-affiliate-link-modal')
  }

  get modal() {
    return new BSN.Modal(this.modalElement)
  }

  get copyButton() {
    return document.getElementById('copy-affiliate-link')
  }
}
